var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "edit",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.963,
    height: 17.963,
    viewBox: "0 0 17.963 17.963",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5598",
    "data-name": "Rectangle 5598",
    width: 17.963,
    height: 17.963,
    fill: "#4c5a6a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11633",
    "data-name": "Group 11633",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_224420",
    "data-name": "Path 224420",
    d: "M17.258,5.894a2.4,2.4,0,0,0,0-3.4L15.469.709a2.4,2.4,0,0,0-3.4,0L.91,11.865a3.1,3.1,0,0,0-.905,2.364l0,2.856a.874.874,0,0,0,.877.877l2.856,0A3.1,3.1,0,0,0,6.1,17.053a.878.878,0,1,0-1.242-1.242,1.357,1.357,0,0,1-1.042.393c-.018,0-.039,0-.056,0l-2,.007,0-2a.3.3,0,0,0,0-.056,1.357,1.357,0,0,1,.393-1.042l9.3-9.3,2.708,2.708L7.169,13.5a.878.878,0,1,0,1.242,1.242ZM12.69,2.564l.621-.621a.652.652,0,0,1,.919,0L16.02,3.733a.652.652,0,0,1,0,.919l-.621.621Z",
    transform: "translate(0)",
    fill: "#4c5a6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224421",
    "data-name": "Path 224421",
    d: "M245.325,462h-7.911a.877.877,0,1,0,0,1.754h7.911a.877.877,0,0,0,0-1.754",
    transform: "translate(-228.239 -445.792)",
    fill: "#4c5a6a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.758cb57689b78bdbb6e69731293c3ecd.svg";
export { ForwardRef as ReactComponent };